import {tradeHistory, TradeHistory} from "./trade-history/TradeHistoryComponent";
import {
    accountPerformanceChart,
    AccountPerformanceChart
} from "./account-performance-chart/AccountPerformanceChartComponent";
import {
    accountPerformanceKeyIndicators,
    AccountPerformanceKeyIndicators
} from "./key-indicators/KeyIndicatorsComponent";
import {dateRange, DateRange} from "./range/AccountPerformanceDateRangeComponent";

export default function(parentDir: string): string {
    const rootDir = `${parentDir}/components`;

    return angular.module("tfApp.performance.components", [])
                  .component(AccountPerformanceChart, accountPerformanceChart(rootDir))
                  .component(AccountPerformanceKeyIndicators, accountPerformanceKeyIndicators())
                  .component(TradeHistory, tradeHistory())
                  .component(DateRange, dateRange(rootDir))
                  .name;
}
